import React, { useState, Fragment, useEffect, useContext, useRef } from "react";
import { Modal , Button } from "react-bootstrap";
import { _U,_API } from "../../../modules/utils";
import { AppContext } from "../../../components/AppProvider";

function ModalPopup(props) {
  const { showPopup, setShowPopup, activePopupIdx = 0, consoleCfg } = props;
  const { iam } = useContext(AppContext);
  const [modalTitle, setModalTitle] = useState(null);
  const [modalTitleUse, setModalTitleUse] = useState("Y");
  const [modalContents, setModalContents] = useState(null);
  const [closeBtnUse, setCloseBtnUse] = useState("Y");
  const [idx, setIdx] = useState(0);
  const popupStateRef = useRef({ idx: 0, show: false });
  
  useEffect(() => {
    if(idx == 0){
      handleClose();
    }else{
      openModal(idx)
    }
  }, [idx]);

  useEffect(() => {
    popupStateRef.current = { idx, show: showPopup };
  }, [idx, showPopup]);

  const handleClose = () => {
    setIdx(0);
    setShowPopup(false);
  };

  const openModal = async (idx) => {
    const req = {
      path: "/v1/event/session/surveys/modal/popup/detail",
      data : {
        idx : idx,
        eventIdx : consoleCfg?.eventIdx,
        sessionIdx : consoleCfg?.sessionIdx,
      }
    };
    try {
      const res = await _API.post(req);
      const data = res?.data?.data || res?.data;

      if (!data) {
        throw new Error("콘솔 팝업 상세 정보를 확인할 수 없습니다.");
      }
      
      setModalTitle(data.title)
      setModalTitleUse(data.titleShow)
      setCloseBtnUse(data.closeBtnUse)
      
      let contents = data.contents;
      if(contents != null && contents != ""){
        contents = contents.replace("sliUname=","user_name="+iam?.name)
        contents = contents.replace("sliUemail=","user_email="+iam?.email)
        contents = contents.replace("sliUcompany=","user_company="+iam?.companyName)
      }
      setModalContents(contents)
      setShowPopup(true);
    } catch (e) {
      console.error("[ModalPopup] Failed to load popup detail:", e);
      setModalContents(null);
      setShowPopup(false);
      setIdx(0);
    }
   
  };

  const onReceivedMessage = (e) => {
    _U.parseMessage(e).then((data) => {
      switch (data.code) {
          case "SOCKET-RECEIVED":
              return data.data ? JSON.parse(data.data) : null;
      }
    }).then((data) => {
      if (data?.mode === "MODAL_POPUP_OPEN") {
        const nextIdx = Number(data.idx) || 0;
        if (popupStateRef.current.show && popupStateRef.current.idx === nextIdx) {
          return;
        }
        setIdx(0);
        setTimeout(() => setIdx(nextIdx), 0);
      } 
      if (data?.mode === "MODAL_POPUP_CLOSE") {
        setIdx(0)  
      }
      if (data?.mode === "SURVEY_OPEN") {
        setIdx(0);
      }
    });
  };

  const isMinimalPopup = modalTitleUse != "Y" && closeBtnUse != "Y";

  useEffect(() => {
    window.addEventListener("message", onReceivedMessage);
    return () => {
      window.removeEventListener("message", onReceivedMessage);
    };
  }, []);

  // 모달 표시 중 body/html 스크롤 락 — Bootstrap의 body.modal-open만으론 일부 케이스(html, 모바일) 누락 보완
  useEffect(() => {
    if (!showPopup) return;
    const prevBodyOverflow = document.body.style.overflow;
    const prevHtmlOverflow = document.documentElement.style.overflow;
    document.body.style.overflow = "hidden";
    document.documentElement.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prevBodyOverflow;
      document.documentElement.style.overflow = prevHtmlOverflow;
    };
  }, [showPopup]);

  useEffect(() => {
    const nextIdx = Number(activePopupIdx) || 0;
    if (nextIdx <= 0) {
      return;
    }
    if (popupStateRef.current.show && popupStateRef.current.idx === nextIdx) {
      return;
    }
    setIdx(0);
    setTimeout(() => setIdx(nextIdx), 0);
  }, [activePopupIdx]);

  return (
    <Fragment>
      <Modal
        show={showPopup}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        className="survey_container consolePopup_container"
        backdropClassName="consolePopup_backdrop"
      >
        {(modalTitleUse == "Y" || closeBtnUse == "Y") && (
          <div className="modal_header">
            <div className="modal_header_inner">
              <div className="modal_title" id="survey_title">
                {modalTitleUse == "Y" && modalTitle}
              </div>
            </div>
            {closeBtnUse == "Y" && 
              <div className="close" onClick={handleClose}></div>
            }
          </div>
        )}
        <div className={`modal_body ${isMinimalPopup ? "console_popup_body_minimal" : ""}`}>
          <div className="modalInnerHtml" dangerouslySetInnerHTML={{ __html: _U.sanitizeHtml(modalContents) }}></div>
        </div>
      </Modal>
    </Fragment>
  )
}

export default ModalPopup;
